// extracted by mini-css-extract-plugin
export default {"ActionsMenuTab":"styles_ActionsMenuTab__Cm79m","IncompletePaginationContainer":"styles_IncompletePaginationContainer__YbX7N"};